import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { wellnub } from 'network/wellnub.api';
import { setUserLinkRequests } from 'features/user/state/user.slice';

const queryFn = async () => {
  const { data } = await wellnub.get('/v1/client/linkRequest');
  return data;
};

export const useGetLinkRequestsService = isAuthenticated => {
  const dispatch = useDispatch();

  return useQuery('GET_LINK_REQUESTS', queryFn, {
    enabled: isAuthenticated,
    onSuccess: data => {
      dispatch(setUserLinkRequests(data));
    },
  });
};
